import { ITimeoutState } from './TimeoutBlitz-types';

const timeoutState: ITimeoutState = {
    state: {
        timeRemaining: {},
    },
    mutations: {
        setTimeRemaining(state, { playerId, timeRemainingMs }: { playerId: number, timeRemainingMs: number }) {
            state.timeRemaining = {
                ...state.timeRemaining,
                [playerId]: timeRemainingMs,
            };
        },
    },
    actions: {
        setTimeRemaining({ commit }, payload: { playerId: number, timeRemainingMs: number }) {
            commit('setTimeRemaining', payload);
        },
    },
};

export default timeoutState;
